import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { StatusRequisitoPipe } from './status-requisito.pipe';
import { CustomCurrencyPipe } from './custom-currency.pipe';
import { DescricaoTipoRequisitoPipe } from './tipo-requisito.pipe';
import { NormalizeWithNumbersDirective } from 'app/utils/pipes/normalize-text.pipe';
import { NormalizeWithoutNumbersDirective } from 'app/utils/pipes/normalize-text.pipe';
import { AgrupaItensListaPipe } from 'app/utils/pipes/agrupa-itens-lista.pipe';
import { OnlyNumbersDirective } from 'app/utils/pipes/normalize-text.pipe';
import { ObjectPropertyRetrieverPipe } from './object-property.pipe';
import { NomeItemAgregacao } from './nome-item-agregacao.pipe';
import { NomeAtividadePipe } from './tipo-atividade.pipe';
import { FormatadorDistanciaPipe } from './formatador-distancia.pipe';
import { FormatadorTempoPipe } from './formatador.tempo.pipe';
import { DocumentoParceiroPipe, RotuloParceiroPipe } from './rotulo-parceiro.pipe';

@NgModule({
  declarations: [StatusRequisitoPipe, CustomCurrencyPipe, DescricaoTipoRequisitoPipe, 
    NormalizeWithNumbersDirective,
    OnlyNumbersDirective,
    AgrupaItensListaPipe,
    ObjectPropertyRetrieverPipe,
    NormalizeWithoutNumbersDirective,
    NomeItemAgregacao,
    NomeAtividadePipe,
    FormatadorTempoPipe,
    FormatadorDistanciaPipe,
    DocumentoParceiroPipe,
    RotuloParceiroPipe],
  imports: [
    CommonModule
  ],
  exports: [
    StatusRequisitoPipe,
    CustomCurrencyPipe,
    DescricaoTipoRequisitoPipe,
    NormalizeWithNumbersDirective,
    OnlyNumbersDirective,
    AgrupaItensListaPipe,
    NormalizeWithoutNumbersDirective,
    ObjectPropertyRetrieverPipe,
    NomeItemAgregacao,
    NomeAtividadePipe,
    FormatadorTempoPipe,
    FormatadorDistanciaPipe,
    DocumentoParceiroPipe,
    RotuloParceiroPipe,
  ],
  providers: [CurrencyPipe,
    FormatadorTempoPipe,
    FormatadorDistanciaPipe
  ]
})
export class PipesModule { }
